import { Injectable, Injector } from '@angular/core';
import { LoggerService } from './logger.service';
import { cloneDeep } from 'lodash';
import * as i0 from "@angular/core";
/**
 * Service to be injected as a meta reducer to handle logging state changes on Redux Actions
 *
 * @export
 * @class StoreLoggerService
 */
export class StoreLoggerService {
    /**
     * Set this to true to log all store actions
     *
     * @static
     * @memberof StoreLoggerService
     */
    static { this.logAllStoreActions = false; }
    /**
     * Creates an instance of StoreLoggerService.
     * @param {Injector} injector
     * @memberof StoreLoggerService
     */
    constructor(injector) {
        // Need to inject after a timeout to get around cyclical dependencies
        setTimeout(() => {
            const loggerService = injector.get(LoggerService);
            this.logger = loggerService.instance('StoreLogger');
        });
    }
    /**
     * Returns boolean to see if the update-reducers action is called, this is used
     * to filter them out, as the store dev tools triggers this very often (for every
     * previous action).
     *
     * @private
     * @param {string} actionType
     * @returns {boolean} true if it does include update-reducers
     */
    isNgrxRelatedLog(actionType = '') {
        return actionType.includes('@ngrx/store/update-reducers');
    }
    /**
     * Decides if this service should actually log
     * It will log if logAllStoreActions is set, or the debug flag is set
     *
     * @private
     * @returns {boolean} true if it should log
     * @memberof StoreLoggerService
     */
    shouldLog() {
        return !!this.logger;
    }
    /**
     * Logs the given state and action if neccessary
     *
     * @param {*} state
     * @param {Action} action
     * @memberof StoreLoggerService
     */
    logAction(_state, action) {
        if (this.shouldLog() && !this.isNgrxRelatedLog(action.type)) {
            this.logger.debug(`Extended State Logging: ${action.type}`, {
                payload: cloneDeep(action.payload),
                action: action.type
                // state: state // State gets to big, which prevents logs to be pushed to new relic.
            });
        }
    }
    static { this.ɵfac = function StoreLoggerService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StoreLoggerService)(i0.ɵɵinject(i0.Injector)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: StoreLoggerService, factory: StoreLoggerService.ɵfac }); }
}
/**
 * Wraps the reducer with the log action from the service
 *
 * @export
 * @param {StoreLoggerService} storeLogger
 * @returns {MetaReducer<{}, Action>}
 */
export function getActionLoggingReducer(storeLogger) {
    return function (reducer) {
        return function (state, action) {
            try {
                storeLogger.logAction(state, action);
            }
            catch (error) {
                // ignore
                console.error('Error logging action', error);
            }
            return reducer(state, action);
        };
    };
}
//# sourceMappingURL=store-logger.service.js.map